<template>
    <CompassFormItem
        :label="field.props?.formItem?.label || 'Rappel'"
        :error="field.currentError || ''"
        inputSize="none"
        :required="field.required || false"
        :requiredLabel="field.props?.formItem?.requiredLabel || $t.__('common.labels.required')"
        orientation="vertical"
        size="medium"
        class="automation-wizard-task-reminder"
    >
        <div class="automation-wizard-task-reminder-wrapper">
            <div class="reminder-container">
                <CompassSwitch
                    :modelValue="isReminderEnabled"
                    orientation="left"
                    class="reminder-switch"
                    @click="handleToggleReminder"
                />
                <CompassSelect
                    :modelValue="selectedDelay"
                    menuClass="select-menu-reminder-automation"
                    class="select-reminder"
                    :disabled="!isReminderEnabled"
                    @update:modelValue="handleDelayChange"
                >
                    <CompassDropdownOption
                        v-for="option in reminderOptions"
                        :key="option.value"
                        :label="option.label"
                        :value="option.value"
                    />
                </CompassSelect>
            </div>
        </div>
    </CompassFormItem>
</template>

<script>
import { toLower } from 'lodash';

const REMINDER_DEFAULT_DELAY = '15min';

export default {
    name: 'AutomationWizardTaskReminder',
    props: {
        field: {
            type: Object,
            required: true,
        },
        modelValue: {
            type: Object,
            default: () => ({}),
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            enabled: false,
            delay: REMINDER_DEFAULT_DELAY,
            reminderOptions: [
                {
                    label: this.$t.__('activities.activitiesFormPanel.reminder_instant'),
                    value: 'instant',
                },
                {
                    label: toLower(
                        this.$t.__('activities.activitiesFormPanel.reminder_x_unit_before', {
                            count: 5,
                            unit: this.$t.__('common.labels.minutes'),
                        }),
                    ),
                    value: '5min',
                },
                {
                    label: toLower(
                        this.$t.__('activities.activitiesFormPanel.reminder_x_unit_before', {
                            count: 15,
                            unit: this.$t.__('common.labels.minutes'),
                        }),
                    ),
                    value: '15min',
                },
                {
                    label: toLower(
                        this.$t.__('activities.activitiesFormPanel.reminder_x_unit_before', {
                            count: 30,
                            unit: this.$t.__('common.labels.minutes'),
                        }),
                    ),
                    value: '30min',
                },
                {
                    label: toLower(
                        this.$t.__('activities.activitiesFormPanel.reminder_x_unit_before', {
                            count: 1,
                            unit: this.$t.__('common.labels.hour'),
                        }),
                    ),
                    value: '1hour',
                },
                {
                    label: toLower(
                        this.$t.__('activities.activitiesFormPanel.reminder_x_unit_before', {
                            count: 1,
                            unit: this.$t.__('common.labels.day'),
                        }),
                    ),
                    value: '1day',
                },
                {
                    label: toLower(
                        this.$t.__('activities.activitiesFormPanel.reminder_x_unit_before', {
                            count: 1,
                            unit: this.$t.__('common.labels.week'),
                        }),
                    ),
                    value: '1week',
                },
                {
                    label: toLower(
                        this.$t.__('activities.activitiesFormPanel.reminder_x_unit_before', {
                            count: 1,
                            unit: this.$t.__('common.labels.month'),
                        }),
                    ),
                    value: '1month',
                },
            ],
        };
    },
    computed: {
        isReminderEnabled() {
            return this.enabled;
        },
        selectedDelay() {
            return this.delay;
        },
    },
    created() {
        this.initializeFromModelValue();
    },
    methods: {
        initializeFromModelValue() {
            this.enabled = this.modelValue?.enabled ?? false;
            this.delay = this.modelValue?.delay ?? REMINDER_DEFAULT_DELAY;
        },
        handleToggleReminder() {
            this.enabled = !this.enabled;
            this.emitUpdate();
        },
        handleDelayChange(delay) {
            this.delay = delay;
            this.emitUpdate();
        },
        emitUpdate() {
            this.$emit('update:modelValue', {
                enabled: this.enabled,
                delay: this.delay,
            });
        },
    },
};
</script>

<style scoped lang="scss">
.automation-wizard-task-reminder-wrapper {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-3);
}

.automation-wizard-task-reminder {
    .reminder-container {
        align-items: center;
        display: flex;
        gap: var(--spacing-4);
    }

    .reminder-inapp {
        margin-bottom: var(--spacing-1);
    }

    .select-reminder {
        flex-grow: 1;
    }
}
</style>

<style lang="scss">
#compass-dropdown-container {
    .select-menu-reminder-automation {
        z-index: 1001;
        width: fit-content;
    }
}
</style>
